import Axios from 'axios';

var headers = {
    'Content-Type': 'application/json',


}

const BASE_URL = '/api';
export default {

    getAll() {

        return Axios.get(BASE_URL+ '/banktran',{ headers: headers });
    },
    add(data) {

        return Axios.post(BASE_URL+ '/banktran', data,{ headers: headers });
    },

    update(data) {

        return Axios.put(BASE_URL+ '/banktran/'  +data.id, data,{ headers: headers });
    },

    delete(id) {

        return Axios.delete(BASE_URL  + '/banktran/'+ id,{ headers: headers });
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/banktrans.js